// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2UnsH","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2-37N","obliqueLine":"membershipbadge_obliqueLine__2QtjP"};